import axios,  {type AxiosRequestConfig, type AxiosResponse  } from 'axios';
import {API_ENDPOINTS} from "@/global/api/config/api-endpoints";
import {ConstService} from "@/service/ConstService";
import router from "@/router";
import AuthService from "@/service/auth/AuthService";
import { ErrorHandler, errorMessages } from '@/global/api/handler/ErrorHandler'

// 기본 API 설정
export const defaultApiClient = axios.create({
    baseURL: API_ENDPOINTS.BASE,
    withCredentials: false,
    timeout: 10000,
    headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
    }
});

// 요청 인터셉터
defaultApiClient.interceptors.request.use(
    (config) => {
        // 토큰이 필요한 경우 헤더에 추가
        const token = localStorage.getItem(ConstService.localStorage.ACCESS_TOKEN);

        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// 응답 인터셉터
defaultApiClient.interceptors.response.use(
    (response) => {
        return response.data;
    },
    async (error) => {
        const originalRequest = error.config;
        const token = AuthService.getToken();

        const status = error.response?.status
        const errorMessage = errorMessages[status] || errorMessages.default
        console.log('error.response.data.error : ', error.response.data.error)
        console.log('error.config : ', error.config)
        console.log('originalRequest : ', error.config._retry)
        // 상태 코드별 다른 처리
        switch (status) {
            case 401:
                if(!error.config._retry) {
                    return AuthService.getTokenManager().handleTokenRefresh(
                        originalRequest,
                        () => AuthService.refreshAccessToken(),
                        async () => await AuthService.handleLogout(router)
                    );
                }
                if(!token) {
                    ErrorHandler.showErrorModal('인증 에러', errorMessage)
                    return Promise.reject(error);
                }
                /*ErrorHandler.showErrorModal('인증 에러2', errorMessage)
                await router.push({name: 'login'})*/
                break
            case 403:
                // 권한 에러도 모달로 표시
                ErrorHandler.showErrorModal(error.response.data.error.title, error.response.data.error.details)
                await router.push('/forbidden')
                break
            case 400:
                ErrorHandler.showErrorModal(error.response.data.error.title, error.response.data.error.details)
                break
            case 500:
                ErrorHandler.showErrorModal(ConstService.ERR.TITLE.SYSTEM_ERROR, error.response.data.error.title + ConstService.BR_TAG + error.response.data.error.details)
                break
            default:
                ErrorHandler.showToast(errorMessage)
        }

        return Promise.reject(error);
    }
);

// defaultAPI 함수
export const defaultAPI = async <T = any>(config: AxiosRequestConfig): Promise<T> => {
    try {
        const response: AxiosResponse<T> = await defaultApiClient(config);
        return response.data; // response.data를 반환
    } catch (error) {
        throw error;
    }
};

/**
 // 사용할 때
 const products = await defaultAPI<Product[]>({
 url: '/products',
 method: 'GET'
 });
 */